import React from 'react';
import './UpgradeModal.css';

/**
 * UpgradeModal Component
 *
 * Displays when a free user tries to access paid features
 * Shows benefits of upgrading and provides CTA to Sentia billing page
 *
 * @param {boolean} show - Whether to display the modal
 * @param {function} onClose - Callback when modal is closed
 * @param {string} feature - Feature name (e.g., "Unlimited Workspaces")
 * @param {array} benefits - Array of benefit strings to display
 * @param {string} currentLimit - Current limit description (e.g., "1/1 workspace")
 */
const UpgradeModal = ({ show, onClose, feature, benefits, currentLimit }) => {
  if (!show) return null;

  const handleUpgrade = () => {
    // Open Sentia billing page in new tab
    window.open('https://sentia-app.com/billing/upgrade?product=sentia-tasks', '_blank');
  };

  const handleBackdropClick = (e) => {
    // Only close if clicking the backdrop, not the modal content
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="upgrade-modal-overlay" onClick={handleBackdropClick}>
      <div className="upgrade-modal" onClick={(e) => e.stopPropagation()}>
        <button className="upgrade-modal-close" onClick={onClose} aria-label="Close">
          ×
        </button>

        <div className="upgrade-modal-icon">🚀</div>

        <h2 className="upgrade-modal-title">
          Upgrade to Unlock {feature}
        </h2>

        {currentLimit && (
          <p className="upgrade-modal-limit">
            You've reached your free plan limit ({currentLimit})
          </p>
        )}

        <div className="upgrade-modal-benefits">
          <h3>Upgrade to get:</h3>
          <ul>
            {benefits && benefits.map((benefit, index) => (
              <li key={index}>
                <span className="benefit-checkmark">✓</span> {benefit}
              </li>
            ))}
          </ul>
        </div>

        <div className="upgrade-modal-actions">
          <button className="btn-primary" onClick={handleUpgrade}>
            Upgrade Now
          </button>
          <button className="btn-secondary" onClick={onClose}>
            Maybe Later
          </button>
        </div>

        <p className="upgrade-modal-footer">
          Upgrade on the Sentia platform to unlock all features
        </p>
      </div>
    </div>
  );
};

export default UpgradeModal;
